module.exports = __webpack_public_path__ + "static/img/egg_r_10.e284539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_10.png
// module id = AYxo
// module chunks = 1